import { render, staticRenderFns } from "./AjaxLoader.vue?vue&type=template&id=478d6bae&"
import script from "./AjaxLoader.vue?vue&type=script&lang=js&"
export * from "./AjaxLoader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports